// src/pages/Analytics.jsx
// Same layout shell as Dashboard: existing Sidebar on the left, content in main.
// Only the content (AnalyticsPanel) is new for this feature.
import React, { useLayoutEffect, useState } from 'react';
import Sidebar from '../components/dashboard/Sidebar';
import AnalyticsPanel from '../components/dashboard/AnalyticsPanel';
import '../styles/Dashboard.css';
import '../styles/Sidebar.css';

export default function Analytics() {
  const user = JSON.parse(localStorage.getItem('user'));
  const [sizes, setSizes] = useState({ top: 56, bottom: 56 });

  useLayoutEffect(() => {
    const header =
      document.querySelector('.global-header') || document.querySelector('header');
    const footer =
      document.querySelector('.global-footer') || document.querySelector('footer');
    setSizes({
      top: header ? header.getBoundingClientRect().height : 56,
      bottom: footer ? footer.getBoundingClientRect().height : 56,
    });
  }, []);

  if (!user) {
    return (
      <div style={{ padding: 24 }}>
        <h1>Analytics</h1>
        <p>Please log in to view your analytics.</p>
      </div>
    );
  }

  const cssVars = {
    '--rv-topbar-height': `${sizes.top}px`,
    '--rv-footer-height': `${sizes.bottom}px`,
    '--rv-sidebar-width': '240px',
  };

  return (
    <div className="dashboard-layout" style={cssVars}>
      <Sidebar />
      <main className="dashboard-main">
        <AnalyticsPanel />
      </main>
    </div>
  );
}
